import React from 'react';
import { CheckCircle } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { GoogleSignInButton } from './GoogleSignInButton';
import { useLocation } from 'react-router-dom';
import { googleAuthError } from '../utils/googleAuth';

export const GoogleAccountConnection = () => {
  const { user } = useAuth();
  const { language } = useLanguage();
  const location = useLocation();
  return (
    <div className="mt-6 pt-6 border-t border-pp-border" data-testid="google-account-connection">
      <div className="flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
      <span className="font-medium text-pp-text" data-testid="google-connection-heading">
        {language === 'fr' ? 'Connexion Google' : 'Google sign-in'}
      </span>
      {user?.google_connected ? (
        <span className="inline-flex items-center gap-2 text-sm text-emerald-700" data-testid="google-connection-status">
          <CheckCircle size={20} weight="fill" aria-hidden="true" />
          {language === 'fr' ? 'Compte associé' : 'Connected'}
        </span>
      ) : <GoogleSignInButton intent="link" testId="google-connect-button" className="w-full sm:w-auto" />}
      </div>
      {location.state?.googleError && (
        <p role="alert" className="mt-3 text-sm text-pp-error" data-testid="google-connection-error">
          {googleAuthError(location.state.googleError, language)}
        </p>
      )}
    </div>
  );
};